import { createContext } from "react";

export const FormBoundaryContext = createContext<undefined | string>(undefined);
